import Vue from 'vue'

/**
 * Importer la configuration d'une autre organisation : abonnements, profils d'équipement, politiques de recharge
 * (retours de la démo, R3). Tout est copié ; le serveur choisit l'abonnement de chaque profil.
 */
class ConfigurationImportRepository {

  // GET /api/commissioning/configuration-import/{organizationId}?from= → { subscriptions, profiles, policies }
  // En GET, les paramètres passent par `data` (auth.fetch ne recopie pas `params`).
  catalogue(organizationId, fromOrganizationId) {
    return this.fetch({ url: `/api/commissioning/configuration-import/${organizationId}`, method: 'get', data: { from: fromOrganizationId } })
  }

  // POST { fromOrganizationId, policyIds, profileIds, subscriptionIds } → { subscriptions, profiles, policies, warnings }
  run(organizationId, selection) {
    return this.fetch({ url: `/api/commissioning/configuration-import/${organizationId}`, method: 'post', data: selection })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new ConfigurationImportRepository()
